module.exports = __webpack_public_path__ + "de.2973308614aa390d43af.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/de.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/de.svg
// module chunks = styles